/* Square renders wishlist prices after the theme. Normalize only its displayed
   price text, retaining native currency conversion and non-zero cents. */
(() => {
  let pending = false;
  const format = () => {
    pending = false;
    document.querySelectorAll('.Vtl-WishlistProduct__Price').forEach(price => {
      const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const next = node.nodeValue.replace(/([.,])00(?=\s*(?:[A-Z]{3})?\s*$)/, '').replace(/\s+[A-Z]{3}\s*$/, '');
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(format); } };
  const start = () => { format(); new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, characterData:true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
